import { Card, Text, nFormatter } from "@asayinc/component-library";
import { Box, Stack } from "@mui/material";
import { TooltipProps } from "recharts";

const ProxyDetailGraphTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<number, string>) => {
  // reverse array to put "Shares" before "Shareholders"
  const sortedPayload = [...(payload || [])].reverse();
  if (active && sortedPayload && sortedPayload.length) {
    return (
      <Card
        data-testid="graph-tooltip"
        elevation={8}
        sx={{ px: 4, py: 3, borderRadius: 2 }}
      >
        <Text variant="body3" emphasis="medium_high" mb={1.5}>
          As of {label}
        </Text>
        {sortedPayload.map((itm) => (
          <Stack key={itm.color} direction="row" alignItems="center" mb={1}>
            <Box
              bgcolor={itm.color}
              width={8}
              height={8}
              borderRadius="100%"
              mr={2}
            />
            <Text variant="body3">
              {nFormatter(itm.value || 0)} {itm.dataKey}
            </Text>
          </Stack>
        ))}
      </Card>
    );
  }

  return null;
};

export default ProxyDetailGraphTooltip;
